import { PropsWithChildren, CSSProperties } from 'react'
import { useInView } from '../hooks/useInView'

type Props = {
  delayMs?: number
  y?: number
  once?: boolean
  className?: string
  /** Feintuning gegen Flackern: */
  enterThreshold?: number
  exitThreshold?: number
  rootMargin?: string
  durationMs?: number
}

export default function Reveal({
  children,
  delayMs = 0,
  y = 16,
  once = false,               // bidirektional als Standard
  className = '',
  enterThreshold = 0.55,
  exitThreshold = 0.25,
  rootMargin = '-80px 0px -20% 0px',
  durationMs = 700,
}: PropsWithChildren<Props>) {
  const { ref, inView } = useInView<HTMLDivElement>({
    once,
    enterThreshold,
    exitThreshold,
    rootMargin,
  })

  const style: CSSProperties = {
    transitionProperty: 'opacity, transform',
    transitionDuration: `${durationMs}ms`,
    transitionTimingFunction: 'cubic-bezier(0.22, 1, 0.36, 1)',
    transitionDelay: `${delayMs}ms`,
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateY(0px)' : `translateY(${y}px)`,
    willChange: 'opacity, transform',
  }

  return (
    <div ref={ref} style={style} className={className}>
      {children}
    </div>
  )
}
